export const QR_CODE_LOGIN = 'qr-code-login';
export const RECEIVER_GROUP = 'receiver';
export const GIVER_GROUP = 'giver';
export const CHECK_IN = 'check-in';
